import React from "react";
import ReactDOM from "react-dom";
import Dropdown from "react-bootstrap/Dropdown";
import PropTypes from "prop-types";
import styled, { withTheme } from "styled-components";

const StyledDropdown = styled(Dropdown)`
  .dropdown-toggle {
    border-radius: 0.4rem;
    border: 2px solid transparent;
    font-weight: 600;
    padding: 0.25rem 0.7rem;
    font-size: 0.875rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    color: ${(props) => props?.theme?.white} !important;
    background-color: ${(props) => props?.theme?.darkPurple} !important;
    border-color: ${(props) => props?.theme?.darkPurple} !important;
    &:hover {
      color: ${(props) => props?.theme?.white} !important;
      background-color: ${(props) => props?.theme?.persianIndigo} !important;
      border-color: ${(props) => props?.theme?.persianIndigo} !important;
    }
    &:focus {
      color: ${(props) => props?.theme?.white} !important;
      background-color: ${(props) => props?.theme?.darkPurple} !important;
      border-color: ${(props) => props?.theme?.darkPurple} !important;
      box-shadow: ${(props) => props?.theme?.primaryShadow} !important;
    }
    &:disabled,
    &:not(:disabled):not(.disabled):active,
    :not(:disabled):not(.disabled).active,
    .show > .dropdown-toggle {
      color: ${(props) => props?.theme?.white} !important;
      background-color: ${(props) => props?.theme?.lavenderRose} !important;
      border-color: ${(props) => props?.theme?.lavenderRose} !important;
    }
    &:not(:disabled):not(.disabled):active:focus,
    .show > .dropdown-toggle:focus {
      box-shadow: ${(props) => props?.theme?.lavenderShadow} !important;
    }
    &::after {
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      content: "\f078";
      border: 0px;
      margin-left: 30px;
    }
  }
  &.checked {
    .dropdown-toggle {
      &::before {
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: "\f058";
        border: 0px;
        opacity: 0.5;
        position: absolute;
        right: 35px;
      }
    }
  }

  &.show > .btn-primary.dropdown-toggle:focus {
    box-shadow: 0px 3px 6px #0000001a;
  }

  .dropdown-menu {
    box-shadow: 0px 3px 6px #0000004d;
    border-radius: 7px;
    border: 0;
    color: black;
    font-weight: 600;
    font-size: 16px;

    .dropdown-item {
      color: black;
      font-weight: 600;
      font-size: 16px;
      padding: 5px 15px;
      &.disabled {
        background-color: transparent;
        color: gray;
        border: none;
        box-shadow: none;
      }
    }
  }
`;

const ButtonDropdownMenu = (props) => {
  let { children, placeInElement = document.body } = props;
  if (!placeInElement) {
    placeInElement = document.body;
  }
  return ReactDOM.createPortal(
    <Dropdown.Menu className="shadow-sm" flip>
      {children}
    </Dropdown.Menu>,
    placeInElement
  );
};

const ButtonDropdown = (props) => {
  const { title, options, size, checked, align, dataTestId } = props;

  return (
    <StyledDropdown size={size} className={checked && "checked"} align={align}>
      <Dropdown.Toggle data-testid={dataTestId}>{title}</Dropdown.Toggle>

      <ButtonDropdownMenu>
        {options.map((item) => {
          if (item?.isVisible) {
            return (
              <Dropdown.Item
                key={`key_${item?.id ?? item}`}
                data-testid={`item-${item?.id ?? item}`}
                className={item?.isDisabled && `disabled`}
              >
                <div onClick={item?.onClick}>{item?.text}</div>
              </Dropdown.Item>
            );
          }

          return null;
        })}
      </ButtonDropdownMenu>
    </StyledDropdown>
  );
};

ButtonDropdown.defaultProps = {
  title: null,
  options: null,
  size: null,
  checked: false,
  dataTestId: "btn-dropdown",
};

ButtonDropdown.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  size: PropTypes.string,
  checked: PropTypes.bool,
  dataTestId: PropTypes.string,
};

export default withTheme(ButtonDropdown);
